export default __webpack_public_path__ + "static/people_hero-ff20c5bb4f5b8e8e0008d7828b605c1f.jpeg";